/** Shell browse: teléfono (<768px) vs desktop header + páginas Desktop*. */
export const MOBILE_SHELL_BREAKPOINT_PX = 768 as const
export const DESKTOP_SHELL_MEDIA = `(min-width: ${MOBILE_SHELL_BREAKPOINT_PX}px)` as const
export const MOBILE_SHELL_MEDIA = `(max-width: ${MOBILE_SHELL_BREAKPOINT_PX - 1}px)` as const

/** Nutri-Matic: tableta flotante (≥1024px) vs mobile-simple full-viewport. */
export const NUTRIMATIC_TABLET_BREAKPOINT_PX = 1024 as const
export const NUTRIMATIC_TABLET_MEDIA = `(min-width: ${NUTRIMATIC_TABLET_BREAKPOINT_PX}px)` as const
export const NUTRIMATIC_MOBILE_MEDIA = `(max-width: ${NUTRIMATIC_TABLET_BREAKPOINT_PX - 1}px)` as const

/** Ancho de columna de contenido: tope fijo desde el shell desktop (≥768px). */
export const CONTENT_WIDTH_BREAKPOINT_PX = MOBILE_SHELL_BREAKPOINT_PX

/** Espaciador al final del scroll browse (altura = bottom nav flotante + FAB). */
export const MOBILE_BOTTOM_NAV_SPACER = 'mobile-app__bottom-nav-spacer' as const

/** @deprecated Usar MOBILE_BOTTOM_NAV_SPACER */
export const MOBILE_BOTTOM_NAV_CLEARANCE = MOBILE_BOTTOM_NAV_SPACER

/** @deprecated Usar MOBILE_BOTTOM_NAV_SPACER */
export const MOBILE_BOTTOM_NAV_PADDING = MOBILE_BOTTOM_NAV_SPACER

/** Ancho del drawer lateral móvil (espacio para widget wallet apilado). */
export const MOBILE_DRAWER_WIDTH = 'w-[min(100vw,20rem)]' as const

/**
 * Ancho máximo del cuerpo de contenido (mobile-first).
 * Tope fijo en md+ (shell desktop); max-w-5xl en 2xl+.
 */
export const CONTENT_MAX_WIDTH = 'md:max-w-[940px] 2xl:max-w-5xl' as const

/** Padding horizontal compartido (main, drawer, paneles alineados al borde). */
export const CONTENT_PADDING_X = 'px-4 sm:px-6 md:px-8 2xl:px-10' as const

/** Padding vertical del área de scroll principal. */
export const CONTENT_PADDING_Y = 'py-4 sm:py-6 md:py-8' as const

/**
 * Contenedor del cuerpo de página (Home e interiores).
 * Una sola fuente de verdad para márgenes visibles y tope de ancho responsivo.
 */
export const INTERIOR_PAGE_CONTAINER =
  'mx-auto w-full px-4 sm:px-6 md:max-w-[940px] md:px-8 2xl:max-w-5xl 2xl:px-10 py-4 sm:py-6 md:py-8' as const

/** Contenedor más ancho para el workspace de swap (chart + trade en dos columnas). */
export const SWAP_PAGE_CONTAINER =
  'mx-auto w-full max-lg:mx-0 max-lg:max-w-none max-lg:h-full max-lg:min-h-0 max-lg:p-0 max-lg:py-0 md:max-w-[1100px] md:px-8 2xl:max-w-6xl 2xl:px-10 md:py-8 py-4 sm:py-6' as const

/** @deprecated Usar INTERIOR_PAGE_CONTAINER. */
export const HOME_CONTENT_CONTAINER = INTERIOR_PAGE_CONTAINER

/** Padding horizontal del interior del drawer lateral (misma lógica que el main). */
export const DRAWER_CONTENT_PADDING_X = 'px-4 sm:px-5' as const
